import { render, staticRenderFns } from "./UsersPage.vue?vue&type=template&id=77c0f4a6&scoped=true&lang=pug&"
import script from "./UsersPage.vue?vue&type=script&lang=ts&"
export * from "./UsersPage.vue?vue&type=script&lang=ts&"
import style0 from "./UsersPage.vue?vue&type=style&index=0&id=77c0f4a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c0f4a6",
  null
  
)

export default component.exports